import { useEffect } from "react";

export interface WidgetMessage
{
    status: string;
    operation_id?: number;
    [key: string]: any;
}

// El widget notifica el final del flujo enviando la cadena "flow completed",
// no un objeto. Se mantiene la comprobación por objeto como respaldo.
const WidgetCompletedMessage = "flow completed";

// En local el widget se sirve desde widget-local.wealthreader.com:8080,
// por eso se valida el dominio en lugar del origen exacto.
const isWealthReaderOrigin = (origin: string): boolean =>
{
    try
    {
        return new URL(origin).hostname.endsWith("wealthreader.com");
    }
    catch
    {
        return false;
    }
};

export const useWealthReaderListener = (onCompleted: () => void) =>
{
    useEffect(() =>
    {
        const handleMessage = (event: MessageEvent) =>
        {
            if(!event.data)
            {
                return;
            }

            if(!isWealthReaderOrigin(event.origin))
            {
                return;
            }

            const isCompleted = event.data === WidgetCompletedMessage
                || (event.data as WidgetMessage)?.status === "completed";

            if(isCompleted)
            {
                onCompleted();
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [onCompleted]);
};
